import api from './api_config';

export async function getCalendarDay(dt) {
  const result = await api.get('/api/reserve/calendar/' + dt);
  return result.data;
}

export async function validate(order) {
  const result = await api.post('/api/reserve/validate', order);
  return result.data;
}

export async function ModiValidate(order) {
  const result = await api.post('/api/reserve/ModiValidate', order);
  return result.data;
}

export async function pledgeValid(order) {
  const result = await api.post('/api/reserve/pledgeValid', order);
  return result.data;
}

export async function calculatePrice(order) {
  //const token = await api.get('/getTokeCSRF');
  //console.log(token.data);
  const result = await api.post('/api/reserve/calculatePrice', order);
  return result.data;
}

export async function postOrder(order) {
  //const token = await api.get('/getTokeCSRF');
  //console.log(token.data);
  return api.post('/api/reserve/order', order);
}

export async function postOrderPrumee(order) {
  return api.post('/api/reserve/orderPrumee', order);
}

export async function getPaymentInfo(expVisitRvdt) {
  const result = await api.get('/payment/info?expVisitRvdt=' + expVisitRvdt);
  return result.data;
}

export async function getOrderSheet(bundleRvNo) {
  return api.get('/api/reserve/orderSheet/' + bundleRvNo);
}

export async function getReservations(param) {
  const queryString = '?' + new URLSearchParams(param).toString();
  return api.get('/api/reserve/reservations' + queryString);
}

export async function getReservation(bundleRvNo) {
  const result = await api.get('/api/reserve/reservations/' + bundleRvNo);
  return result.data;
}

export async function getReservationPdDetail(pdRvNo, mode = '') {
  const result = await api.get('/api/reserve/reservations/detail/' + pdRvNo + '?mode=' + mode);
  return result.data;
}

export async function getReservationPdDetailExperList(pdRvNo, pdNo, scheSeqNo, expVisitRvdt) {
  const result = await api.get(`/api/reserve/reservations/detail/${pdRvNo}/experList?pdNo=${pdNo}&scheSeqNo=${scheSeqNo}&expVisitRvdt=${expVisitRvdt}`);
  return result.data;
}

export async function postReservationPdExperInfo(pdRvNo, reserve) {
  const result = await api.post('/api/reserve/reservations/detail/' + pdRvNo + '/experInfo', { ...reserve });
  return result.data;
}

export async function postReservationPdLeaderInfo(pdRvNo, reserve) {
  const result = await api.post('/api/reserve/reservations/detail/' + pdRvNo + '/leaderInfo', { ...reserve });
  return result.data;
}

/**가족정보 불러오기, linkCd: 1 - 보호자, 2 - 체험자 */
export async function getFamilyList(linkCd) {
  const result = await api.get('/api/reserve/getFamilyList?linkCd=' + linkCd);
  return result.data;
}

export async function getOrgInfos(orgNm) {
  const result = await api.get('/api/reserve/hpOrgInfos?orgNm=' + orgNm);
  return result.data;
}

export async function getCouponList(booking) {
  const result = await api.post('/api/reserve/getCouponList', booking);
  return result.data;
}

export async function postWait(reserveWait) {
  const result = await api.post('/api/reserve/wait', reserveWait);
  return result.data;
}

export async function calcModifyPrice(modifyBooking) {
  const result = await api.post('/api/reserve/calcModifyPrice', modifyBooking);
  return result.data;
}

export async function modifyReserve(modifyBooking) {
  const result = await api.post('/api/reserve/modfiyPayment', modifyBooking);
  return result.data;
}

export async function calcCancelPrice(cancel) {
  const result = await api.post('/api/reserve/calcCancelPrice', cancel);
  return result.data;
}

export async function cancelReserve(cancel) {
  const result = await api.post('/api/reserve/cancelPayment', cancel);
  return result.data;
}

/** 결제관련 */
export async function getLgupayInfo(order) {
  const result = await api.post('/payment/getLgupayInfo.do', order);
  return result.data;
}
